export default __webpack_public_path__ + "static/media/create-account-page.dadd1b8d.png";